export class SortTypeMapDto {
  key: string;
  desc: boolean;

  constructor(key: string, desc: boolean) {
    this.key = key;
    this.desc = desc;
  }
}
